export default __webpack_public_path__ + "static/biodiversity-banner-d106f08e5b5cb3f92795549e594b0006.png";